import React, { useState } from "react";
import "./Header.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSortDown } from "@fortawesome/free-solid-svg-icons";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import HeaderNav from "../../_nav";
import { Nav } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import logo from "../../assets/images/header/logo.png";
import logout from "../../assets/images/header/logout.png";
import notification from "../../assets/images/header/notification.png";
import user from "../../assets/images/header/user.png";
import User_Management_Modal from "../header_components/user_management_modal/User_Management_Modal";
import Profile_Offcanvas from "../header_components/profile_offcanvas/Profile_Offcanvas";
import Notifications from "../header_components/notifications/Notifications";
import { useNavigate } from "react-router-dom";
const Header = () => {
   const navigate = useNavigate();
  const [viewNotification, setNotificationView] = useState(false);
  const location = useLocation();
  const currentPath = location.pathname;

  const [showUserModal, setShowUserModal] = useState(false);
  const [showProfileOffcanvas, setShowProfileOffcanvas] = useState(false);

  return (
    <section className="Header">
      <div className="container-fluid">
        <div className="top_section">
          <div className="logo_holder">
            <img src={logo} className="logo_img" />
          </div>

          <div className="right_side">
            <div className="img_text_div" onClick={() => navigate("/login")}>
              <img src={logout} className="inner_img" />
              <p className="inner_text">Logout</p>
            </div>

            <div
              className="img_text_div"
              onClick={() => setNotificationView(true)}
            >
              <img src={notification} className="inner_img" />
              <p className="inner_text">Notification</p>
            </div>

            <div
              className="img_text_div"
              onClick={() => {
                setShowProfileOffcanvas(true);
              }}
            >
              <img src={user} className="inner_img" />
              <p className="inner_text">Profie</p>
              <FontAwesomeIcon icon={faSortDown} className="inner_icon" />
            </div>
          </div>
        </div>

        <div className="all_navs_holder">
          <Swiper
            spaceBetween={16}
            slidesPerView={2}
            breakpoints={{
              0: { slidesPerView: 2.1, spaceBetween: 10 },
              450: { slidesPerView: 3, spaceBetween: 10 },
              450: { slidesPerView: 3.5, spaceBetween: 10 },
              576: { slidesPerView: 4.1, spaceBetween: 10 },
              768: { slidesPerView: 4.1, spaceBetween: 10 },
              992: { slidesPerView: 6, spaceBetween: 10 },
              1200: { slidesPerView: 7.5, spaceBetween: 10 },
              1400: { slidesPerView: 7.5, spaceBetween: 10 },
              1600: { slidesPerView: 10, spaceBetween: 10 },
            }}
          >
            {HeaderNav?.map((nav, index) => {
              console.log("HeaderNav", nav?.path);

              const handleNavClick = (e) => {
                if (nav?.path === "/user-management-modal") {
                  e.preventDefault();
                  setShowUserModal(true);
                }
              };

              return (
                <SwiperSlide key={index}>
                  <Nav.Link
                    as={Link}
                    to={nav?.path}
                    onClick={handleNavClick}
                    className={
                      currentPath === nav?.path ||
                      currentPath.startsWith(nav?.path + "/")
                        ? "active"
                        : ""
                    }
                  >
                    <div className="nav_div">
                      <div className="nav_img_div">
                        <img
                          src={process.env.PUBLIC_URL + nav?.img}
                          className="nav_img"
                          alt={nav?.name}
                        />
                      </div>
                      <p className="nav_text">
                        {nav.name.split("\n").map((line, index) => (
                          <span key={index}>
                            {line}
                            <br />
                          </span>
                        ))}
                      </p>
                    </div>
                  </Nav.Link>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      </div>

      <User_Management_Modal
        show={showUserModal}
        onHide={() => setShowUserModal(false)}
        btnText={"Submit"}
      />
      <Profile_Offcanvas
        show={showProfileOffcanvas}
        handleClose={() => setShowProfileOffcanvas(false)}
      />
      <Notifications
        show={viewNotification}
        handleClose={() => setNotificationView(false)}
      />
    </section>
  );
};

export default Header;
